// extracted by mini-css-extract-plugin
export default {"record-picker":"record-picker__record-picker","record-picker-values":"record-picker__record-picker-values","record-picker-link":"record-picker__record-picker-link"};